export const accountFlagsLoaded = (state) => {
  return state.accountFlags !== null
}

/**
 * Whether a feature exists for the current portal: the account featureFlags response omits
 * flags unavailable to the portal, so presence means availability — no extra request needed.
 * Returns false until account flags are loaded — callers gate like other async menu/view state.
 */
export const isFeatureAvailable = (state) => (flagKey) => {
  return !!state.accountFlags && flagKey in state.accountFlags
}

/**
 * Effective value of a flag for the current account.
 * `fallback` applies until flags are loaded (or if the key is absent) — pass the registry default the caller expects.
 */
export const isFeatureEnabled = (state) => (flagKey, fallback = false) => {
  const flag = state.accountFlags?.[flagKey]

  if (flag) {
    return flag.effective === true || flag.effective === "1"
  }

  return fallback
}

// Portal admins bypass the account-level value but not portal-level availability,
// mirroring server-side enforcement — shared by every "is X allowed" gate below so the
// bypass rule lives in one place instead of being repeated in each consuming component.
const isAllowed = (getters, rootGetters, flagKey) => {
  return getters.isFeatureAvailable(flagKey) && (rootGetters["Profile/isPortalAdmin"] || getters.isFeatureEnabled(flagKey))
}

export const isPlayersAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "webPlayersEnabled")
}

export const isHlsStreamingAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "hlsStreamingEnabled")
}

export const isGeoBlockingAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "geoBlockingEnabled")
}

export const isIpBlockingAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "ipBlockingEnabled")
}

export const isCtlAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "ctlLineEnabled")
}

export const isZasAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "zasEnabled")
}

export const isPodcastRecordingAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "podcastRecordingEnabled")
}

export const isFinanceAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "financeTabEnabled")
}

export const isPodcastBotAllowed = (state, getters, rootState, rootGetters) => {
  return isAllowed(getters, rootGetters, "podcastBotEnabled")
}
